<template>
  <div class="footer">
    <div class="main-content footer-shell">
      <div class="footer-top">
        <div class="footer-company">{{ companyInfo.name }}</div>
        <div class="footer-contact-list">
          <div class="footer-contact-item">
            <span class="footer-icon">
              <img class="footer-icon-image" :src="phoneIcon" alt="电话" />
            </span>
            <span>{{ companyInfo.phone }}</span>
          </div>
          <div class="footer-contact-item">
            <span class="footer-icon">
              <img class="footer-icon-image" :src="qqIcon" alt="QQ" />
            </span>
            <span>{{ companyInfo.qq }}</span>
          </div>
          <div class="footer-contact-item">
            <span class="footer-icon">
              <img class="footer-icon-image" :src="emailIcon" alt="邮箱" />
            </span>
            <span>{{ companyInfo.email }}</span>
          </div>
        </div>
      </div>

      <div class="footer-middle" v-if="!isMobile">
        <div class="footer-address-row">
          <span class="footer-icon footer-icon-address">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M10.8132 10.4664C11.6595 10.7699 12.1913 11.2082 12.1913 11.6958C12.1913 12.6121 10.3142 13.3551 8 13.3551C5.68575 13.3551 3.80874 12.6122 3.80874 11.6958C3.80874 11.2082 4.34046 10.7699 5.18678 10.4664C3.46301 10.8741 2.3 11.645 2.3 12.5286C2.3 13.8378 4.85276 14.8997 8 14.8997C11.1472 14.8997 13.7 13.8378 13.7 12.5286C13.7 11.645 12.537 10.8741 10.8132 10.4664Z"
                fill="currentColor" />
              <path
                d="M8.00049 1.6001C5.55032 1.6001 3.56738 3.49854 3.56738 5.84388C3.56738 6.90152 3.90821 7.64002 4.36266 8.2929C4.77923 8.87957 5.65782 9.67701 6.23219 10.2998C6.86462 10.9708 8.00049 12.3668 8.00049 12.3668C8.00049 12.3668 9.5165 10.5868 9.69952 10.388C9.87618 10.1881 11.0502 9.02201 11.5627 8.38114C12.074 7.74032 12.4338 6.82724 12.4338 5.84388C12.4338 3.49854 10.4507 1.6001 8.00049 1.6001ZM8.00049 7.5821C6.95145 7.5821 6.10063 6.77866 6.10063 5.78727C6.10063 4.79587 6.95145 3.99243 8.00049 3.99243C9.04952 3.99243 9.90043 4.79587 9.90043 5.78727C9.90043 6.77866 9.04952 7.5821 8.00049 7.5821Z"
                fill="currentColor" />
            </svg>
          </span>
          <div class="footer-addresses">
            <div v-for="address in companyInfo.addresses" :key="address" class="footer-address-item">
              <span>{{ address }}</span>
            </div>
          </div>
        </div>

        <div class="footer-qrs">
          <div v-for="card in qrCards" :key="card.title" class="footer-qr-card" @click="openQrPopup(card)">
            <div class="footer-qr-frame">
              <img :src="card.image" :alt="card.title" />
            </div>
            <div class="footer-qr-title">{{ card.title }}</div>
          </div>
        </div>
      </div>

      <div class="footer-bottom" v-if="!isMobile">
        <p>
          <span>Copyright © 2019-{{ year }}</span>
          <span class="footer-divider"></span>
          <span>{{ companyInfo.name }}</span>
          <span class="footer-divider"></span>
          <a target="_blank" href="https://beian.miit.gov.cn/">{{ companyInfo.icp }}</a>
        </p>
      </div>
      <div class="contact-icon" v-if="isMobile">
        <div class="contact-icon-item">
          <div class="tip-img">
            <img src="../assets/weixin.jpg" alt="微信二维码" srcset="" />
          </div>
          <svg class="tip-svg" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"
            @click="toggleWechatPopup">
            <g clip-path="url(#clip0_2152_747)">
              <path
                d="M10.5434 10.6816C9.98851 10.6816 9.43359 11.0516 9.43359 11.6065C9.43359 12.1614 9.98851 12.5314 10.5434 12.5314C11.0983 12.5314 11.4683 12.1614 11.4683 11.6065C11.4683 11.0285 11.0983 10.6816 10.5434 10.6816ZM18.0579 16.0458C17.6879 16.0458 17.3411 16.4389 17.3411 16.7857C17.3411 17.1788 17.7111 17.5256 18.0579 17.5256C18.6128 17.5256 18.9827 17.1556 18.9827 16.7857C18.9827 16.4157 18.6128 16.0458 18.0579 16.0458ZM15.6764 12.5314C16.2313 12.5314 16.6012 12.1383 16.6012 11.6065C16.6012 11.0516 16.2313 10.6816 15.6764 10.6816C15.1215 10.6816 14.5665 11.0516 14.5665 11.6065C14.5665 12.1614 15.1215 12.5314 15.6764 12.5314ZM22.081 16.0458C21.7111 16.0458 21.3642 16.4389 21.3642 16.7857C21.3642 17.1788 21.7342 17.5256 22.081 17.5256C22.6359 17.5256 23.0058 17.1556 23.0058 16.7857C23.0058 16.4157 22.6359 16.0458 22.081 16.0458Z"
                fill="#929EB0" />
              <path
                d="M15.9538 0.0927734C7.14451 0.0927734 0 7.23728 0 16.0465C0 24.8558 7.14451 32.0003 15.9538 32.0003C24.763 32.0003 31.9075 24.8558 31.9075 16.0465C31.9075 7.23728 24.763 0.0927734 15.9538 0.0927734ZM12.9249 20.139C12 20.139 11.2601 19.954 10.3815 19.746L7.83815 21.0408L8.55491 18.798C6.72832 17.5032 5.6185 15.8153 5.6185 13.8038C5.6185 10.2662 8.92486 7.49162 12.9249 7.49162C16.5087 7.49162 19.6763 9.71127 20.3006 12.6939C20.0694 12.6708 19.8382 12.6477 19.6069 12.6477C16.1387 12.6939 13.4104 15.3066 13.4104 18.5436C13.4104 19.0754 13.5029 19.5841 13.6416 20.0928C13.4104 20.1159 13.1561 20.139 12.9249 20.139ZM23.7457 22.7286L24.3006 24.5783L22.3121 23.4685C21.5954 23.6535 20.8555 23.8384 20.1156 23.8384C16.6243 23.8384 13.8728 21.4338 13.8728 18.4512C13.8497 15.4916 16.6012 13.087 20.0694 13.087C23.3757 13.087 26.289 15.5147 26.289 18.4743C26.289 20.139 25.2023 21.6188 23.7457 22.7286Z"
                fill="#929EB0" />
            </g>
            <defs>
              <clipPath id="clip0_2152_747">
                <rect width="32" height="32" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>

        <div class="contact-icon-item">
          <div class="tip-img">
            <p v-for="(address, index) in companyInfo.addresses" :key="index">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M13.5165 13.083C14.5744 13.4624 15.2391 14.0104 15.2391 14.6199C15.2391 15.7652 12.8928 16.694 10 16.694C7.10719 16.694 4.76093 15.7653 4.76093 14.6199C4.76093 14.0104 5.42557 13.4625 6.48348 13.083C4.32876 13.5927 2.875 14.5562 2.875 15.6607C2.875 17.2973 6.06595 18.6247 10 18.6247C13.934 18.6247 17.125 17.2973 17.125 15.6607C17.125 14.5562 15.6712 13.5927 13.5165 13.083Z"
                  fill="#50627F" />
                <path
                  d="M10.0007 2C6.9379 2 4.45898 4.37305 4.45898 7.30473C4.45898 8.62678 4.88502 9.5498 5.45308 10.3659C5.97379 11.0992 7.07202 12.096 7.78998 12.8745C8.58052 13.7132 10.0007 15.4583 10.0007 15.4583C10.0007 15.4583 11.8957 13.2359 12.1245 12.9874C12.3454 12.7375 13.8129 11.2799 14.4535 10.4788C15.0926 9.67778 15.5423 8.53643 15.5423 7.30473C15.5423 4.37305 13.0634 2 10.0007 2ZM10.0007 9.47752C8.6894 9.47752 7.62588 8.47319 7.62588 7.23396C7.62588 5.99474 8.6894 4.99041 10.0007 4.99041C11.3119 4.99041 12.3754 5.99474 12.3754 7.23396C12.3754 8.47319 11.3119 9.47752 10.0007 9.47752Z"
                  fill="#50627F" />
              </svg>{{ address }}
            </p>
          </div>
          <svg class="tip-svg" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"
            @click="toggleAddressPopup">
            <g clip-path="url(#clip0_2152_750)">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M15.9538 0.0927734C7.14451 0.0927734 0 7.23728 0 16.0465C0 24.8558 7.14451 32.0003 15.9538 32.0003C24.763 32.0003 31.9075 24.8558 31.9075 16.0465C31.9075 7.23728 24.763 0.0927734 15.9538 0.0927734ZM20.4419 20C21.7782 20.4792 22.6178 21.1715 22.6178 21.9413C22.6178 23.3881 19.6541 24.5613 16 24.5613C12.3459 24.5613 9.38222 23.3882 9.38222 21.9413C9.38222 21.1715 10.2218 20.4794 11.5581 20C8.83633 20.6439 7 21.8609 7 23.2561C7 25.3234 11.0307 27 16 27C20.9693 27 25 25.3234 25 23.256C25 21.8609 23.1637 20.6439 20.4419 20ZM9 12.7007C9 8.99754 12.1313 6 16 6C19.8687 6 23 8.99754 23 12.7007C23 14.2565 22.4319 15.6983 21.6247 16.7101C21.0455 17.4344 19.9312 18.5834 19.2423 19.2939C18.9687 19.5761 18.7621 19.7891 18.6828 19.8788C18.3938 20.1927 16 23 16 23C16 23 14.2062 20.7956 13.2076 19.7362C12.8984 19.4009 12.5333 19.0336 12.1604 18.6583C11.4395 17.9329 10.6892 17.1779 10.2557 16.5675C9.53815 15.5366 9 14.3707 9 12.7007ZM13.0003 12.6113C13.0003 14.1767 14.3437 15.4453 16 15.4453C17.6563 15.4453 18.9997 14.1767 18.9997 12.6113C18.9997 11.046 17.6563 9.77736 16 9.77736C14.3437 9.77736 13.0003 11.046 13.0003 12.6113Z"
                fill="#929EB0" />
            </g>
            <defs>
              <clipPath id="clip0_2152_750">
                <rect width="32" height="32" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>

        <!-- 微信二维码弹窗 -->
        <div v-if="showWechatPopup && isMobile" class="mobile-popup wechat-popup">
          <div class="popup-content">
            <div class="popup-header">
              <h3>扫码关注 了解更多</h3>

            </div>
            <div class="popup-body">
              <img src="../assets/footer-qrcode-video.png" alt="" />
              <p>长按识别二维码</p>
            </div>
            <div class="popup-close" @click="toggleWechatPopup">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                <path
                  d="M20.0528 5.67383C12.1031 5.67383 5.65527 12.1203 5.65527 20.0713C5.65527 28.0228 12.1022 34.4688 20.0528 34.4688C28.0042 34.4688 34.4503 28.0242 34.4503 20.0713C34.4505 12.1216 28.0043 5.67383 20.0528 5.67383ZM25.9555 24.0671C26.2002 24.3097 26.3517 24.6461 26.3517 25.0178C26.3517 25.0188 26.3517 25.0198 26.3517 25.0208C26.3517 25.0209 26.3517 25.0211 26.3517 25.0215C26.3517 25.7663 25.7479 26.3701 25.0031 26.3701C24.6302 26.3701 24.2927 26.2188 24.0486 25.9741L20.0529 21.9807L16.0599 25.9754C15.8158 26.2202 15.4783 26.3716 15.1053 26.3716C15.1047 26.3716 15.1041 26.3716 15.1035 26.3716C14.3597 26.3716 13.7549 25.7682 13.7549 25.0215C13.7549 25.0208 13.7549 25.02 13.7549 25.0193C13.7549 24.6479 13.9058 24.3118 14.1496 24.0689L18.1449 20.0714L14.1506 16.0773C13.9067 15.8336 13.7558 15.4968 13.7558 15.1248C13.7558 15.124 13.7558 15.1232 13.7558 15.1223C13.7558 14.3772 14.3601 13.7728 15.1055 13.7728C15.1058 13.7728 15.1064 13.7728 15.1069 13.7728C15.4789 13.7728 15.8156 13.9236 16.0594 14.1675L20.0523 18.1628L24.0481 14.1685C24.2922 13.9246 24.6294 13.7738 25.0017 13.7738C25.747 13.7738 26.3512 14.3779 26.3512 15.1232C26.3512 15.1233 26.3512 15.1235 26.3512 15.1235C26.3512 15.1242 26.3512 15.1252 26.3512 15.1261C26.3512 15.4983 26.1997 15.8351 25.9551 16.0782L21.962 20.0712L25.9554 24.0672L25.9555 24.0671Z"
                  fill="white" fill-opacity="0.3" />
              </svg>
            </div>
          </div>
          <div class="popup-overlay" @click="toggleWechatPopup"></div>
        </div>

        <!-- 公司地址弹窗 -->
        <div v-if="showAddressPopup && isMobile" class="mobile-popup address-popup">
          <div class="popup-content">
            <div class="popup-header">
              <h3>公司地址</h3>
            </div>
            <div class="popup-body">
              <p v-for="(address, index) in companyInfo.addresses" :key="index">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M13.5165 13.083C14.5744 13.4624 15.2391 14.0104 15.2391 14.6199C15.2391 15.7652 12.8928 16.694 10 16.694C7.10719 16.694 4.76093 15.7653 4.76093 14.6199C4.76093 14.0104 5.42557 13.4625 6.48348 13.083C4.32876 13.5927 2.875 14.5562 2.875 15.6607C2.875 17.2973 6.06595 18.6247 10 18.6247C13.934 18.6247 17.125 17.2973 17.125 15.6607C17.125 14.5562 15.6712 13.5927 13.5165 13.083Z"
                    fill="#50627F" />
                  <path
                    d="M10.0007 2C6.9379 2 4.45898 4.37305 4.45898 7.30473C4.45898 8.62678 4.88502 9.5498 5.45308 10.3659C5.97379 11.0992 7.07202 12.096 7.78998 12.8745C8.58052 13.7132 10.0007 15.4583 10.0007 15.4583C10.0007 15.4583 11.8957 13.2359 12.1245 12.9874C12.3454 12.7375 13.8129 11.2799 14.4535 10.4788C15.0926 9.67778 15.5423 8.53643 15.5423 7.30473C15.5423 4.37305 13.0634 2 10.0007 2ZM10.0007 9.47752C8.6894 9.47752 7.62588 8.47319 7.62588 7.23396C7.62588 5.99474 8.6894 4.99041 10.0007 4.99041C11.3119 4.99041 12.3754 5.99474 12.3754 7.23396C12.3754 8.47319 11.3119 9.47752 10.0007 9.47752Z"
                    fill="#50627F" />
                </svg>{{ address }}
              </p>
            </div>
            <div class="popup-close" @click="toggleAddressPopup">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                <path
                  d="M20.0528 5.67383C12.1031 5.67383 5.65527 12.1203 5.65527 20.0713C5.65527 28.0228 12.1022 34.4688 20.0528 34.4688C28.0042 34.4688 34.4503 28.0242 34.4503 20.0713C34.4505 12.1216 28.0043 5.67383 20.0528 5.67383ZM25.9555 24.0671C26.2002 24.3097 26.3517 24.6461 26.3517 25.0178C26.3517 25.0188 26.3517 25.0198 26.3517 25.0208C26.3517 25.0209 26.3517 25.0211 26.3517 25.0215C26.3517 25.7663 25.7479 26.3701 25.0031 26.3701C24.6302 26.3701 24.2927 26.2188 24.0486 25.9741L20.0529 21.9807L16.0599 25.9754C15.8158 26.2202 15.4783 26.3716 15.1053 26.3716C15.1047 26.3716 15.1041 26.3716 15.1035 26.3716C14.3597 26.3716 13.7549 25.7682 13.7549 25.0215C13.7549 25.0208 13.7549 25.02 13.7549 25.0193C13.7549 24.6479 13.9058 24.3118 14.1496 24.0689L18.1449 20.0714L14.1506 16.0773C13.9067 15.8336 13.7558 15.4968 13.7558 15.1248C13.7558 15.124 13.7558 15.1232 13.7558 15.1223C13.7558 14.3772 14.3601 13.7728 15.1055 13.7728C15.1058 13.7728 15.1064 13.7728 15.1069 13.7728C15.4789 13.7728 15.8156 13.9236 16.0594 14.1675L20.0523 18.1628L24.0481 14.1685C24.2922 13.9246 24.6294 13.7738 25.0017 13.7738C25.747 13.7738 26.3512 14.3779 26.3512 15.1232C26.3512 15.1233 26.3512 15.1235 26.3512 15.1235C26.3512 15.1242 26.3512 15.1252 26.3512 15.1261C26.3512 15.4983 26.1997 15.8351 25.9551 16.0782L21.962 20.0712L25.9554 24.0672L25.9555 24.0671Z"
                  fill="white" fill-opacity="0.3" />
              </svg>
            </div>
          </div>
          <div class="popup-overlay" @click="toggleAddressPopup"></div>
        </div>
      </div>

    </div>

    <!-- 微信二维码弹窗 -->
    <!-- <div v-if="showWechatPopup && isMobile" class="mobile-popup wechat-popup">
      <div class="popup-content">
        <div class="popup-header">
          <h3>扫码关注 了解更多</h3>

        </div>
        <div class="popup-body">
          <img src="../assets/weixin.jpg" alt="微信二维码" />
          <p>长按识别二维码</p>
        </div>
        <div class="popup-close" @click="toggleWechatPopup">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path
              d="M20.0528 5.67383C12.1031 5.67383 5.65527 12.1203 5.65527 20.0713C5.65527 28.0228 12.1022 34.4688 20.0528 34.4688C28.0042 34.4688 34.4503 28.0242 34.4503 20.0713C34.4505 12.1216 28.0043 5.67383 20.0528 5.67383ZM25.9555 24.0671C26.2002 24.3097 26.3517 24.6461 26.3517 25.0178C26.3517 25.0188 26.3517 25.0198 26.3517 25.0208C26.3517 25.0209 26.3517 25.0211 26.3517 25.0215C26.3517 25.7663 25.7479 26.3701 25.0031 26.3701C24.6302 26.3701 24.2927 26.2188 24.0486 25.9741L20.0529 21.9807L16.0599 25.9754C15.8158 26.2202 15.4783 26.3716 15.1053 26.3716C15.1047 26.3716 15.1041 26.3716 15.1035 26.3716C14.3597 26.3716 13.7549 25.7682 13.7549 25.0215C13.7549 25.0208 13.7549 25.02 13.7549 25.0193C13.7549 24.6479 13.9058 24.3118 14.1496 24.0689L18.1449 20.0714L14.1506 16.0773C13.9067 15.8336 13.7558 15.4968 13.7558 15.1248C13.7558 15.124 13.7558 15.1232 13.7558 15.1223C13.7558 14.3772 14.3601 13.7728 15.1055 13.7728C15.1058 13.7728 15.1064 13.7728 15.1069 13.7728C15.4789 13.7728 15.8156 13.9236 16.0594 14.1675L20.0523 18.1628L24.0481 14.1685C24.2922 13.9246 24.6294 13.7738 25.0017 13.7738C25.747 13.7738 26.3512 14.3779 26.3512 15.1232C26.3512 15.1233 26.3512 15.1235 26.3512 15.1235C26.3512 15.1242 26.3512 15.1252 26.3512 15.1261C26.3512 15.4983 26.1997 15.8351 25.9551 16.0782L21.962 20.0712L25.9554 24.0672L25.9555 24.0671Z"
              fill="white" fill-opacity="0.3" />
          </svg>
        </div>
      </div>
    </div> -->


    <!-- </div> -->


  </div>
</template>

<script>
import { companyInfo } from '@/config';

export default {
  name: "FooterSection",
  data() {
    return {
      year: new Date().getFullYear(),
      companyInfo,
      phoneIcon: require('../assets/footer-icon-phone.png'),
      qqIcon: require('../assets/footer-icon-qq.png'),
      emailIcon: require('../assets/footer-icon-email.png'),
      showWechatPopup: false,
      showAddressPopup: false,
      activePopupTitle: '',
      activePopupImage: '',
      qrCards: [
        { title: '公众号', image: require('../assets/footer-qrcode-wechat.png') },
        { title: '视频号', image: require('../assets/footer-qrcode-video.png') },
      ],
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 1000;
    }
  },
  methods: {
    toggleWechatPopup() {
      this.showWechatPopup = !this.showWechatPopup;
      if (this.showAddressPopup) {
        this.showAddressPopup = false;
      }
    },
    toggleAddressPopup() {
      this.showAddressPopup = !this.showAddressPopup;
      if (this.showWechatPopup) {
        this.showWechatPopup = false;
      }
    },
    openQrPopup(card) {
      if (!this.isMobile) {
        return;
      }
      this.activePopupTitle = card.title;
      this.activePopupImage = card.image;
      this.showWechatPopup = true;
      this.showAddressPopup = false;
    },
    closePopups() {
      this.showWechatPopup = false;
      this.showAddressPopup = false;
      this.activePopupTitle = '';
      this.activePopupImage = '';
    }
  }
};
</script>

<style scoped>
@media screen and (max-width: 1000px) {
  .main-content {
    /* width: 100vw !important;
    box-sizing: border-box !important;
    margin: 0 !important; */
    padding: 16px 16px !important;
  }

}

.footer {
  background-color: #09142f;
}

.footer-shell {
  padding-top: 46px;
  padding-bottom: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-top {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
  width: 100%;
}

.footer-company {
  color: rgba(255, 255, 255, 0.8);
  font-size: 18px;
  font-weight: 500;
  line-height: normal;
}

.footer-contact-list {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
}

.footer-contact-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
}

.footer-icon {
  width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.8);
  flex-shrink: 0;
}

.footer-icon-image {
  width: 16px;
  height: 16px;
  display: block;
}

.footer-middle {
  margin-top: 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  width: 100%;
}

.footer-address-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.footer-addresses {
  display: flex;
  flex-wrap: wrap;
  gap: 20px 16px;
  max-width: 980px;
  justify-content: center;
}

.footer-address-item {
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.8);
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
}

.footer-icon-address {
  color: #ffffff;
  opacity: 0.8;
}

.footer-qrs {
  display: flex;
  gap: 24px;
  flex-shrink: 0;
  justify-content: center;
}

.footer-qr-card {
  width: 105px;
  padding: 8px;
  border-radius: 9px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.05);
  box-shadow: inset 0 0 7.6px rgba(255, 255, 255, 0.25);
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: default;
}

.footer-qr-frame {
  width: 89px;
  height: 88px;
  padding: 5px;
  border-radius: 7px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-qr-frame img {
  width: 79px;
  height: 79px;
  object-fit: cover;
}

.footer-qr-title {
  margin-top: 8px;
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
}

.contact-icon {
  display: flex;
   margin-top: 14px;
  /*
  margin-bottom: 10px; */
}

.contact-icon .contact-icon-item {
  margin-right: 16px;
  position: relative;
  cursor: pointer;
  /* height: 26px;
  width: 26px;
  padding-top: 20px;
  text-align: left; */
}

.contact-icon .contact-icon-item:last-child {
  width: 50px;
}

.contact-icon .contact-icon-item:hover .tip-svg path {
  fill: #fff;
}

.contact-icon .contact-icon-item .tip-img {
  position: absolute;
  bottom: 16px;
  left: 0;
  height: 168px;
  opacity: 0;
  visibility: hidden;
  border-radius: 8px;
  background-color: #fff;
  padding: 4px;
  z-index: -1;
  transition: opacity 0.3s ease, visibility 0s linear 1s;
}

.contact-icon .contact-icon-item:last-child .tip-img {
  width: 480px;
  padding: 16px;
  height: auto;
}

.contact-icon .contact-icon-item:last-child .tip-img p {
  color: #50627f !important;
  display: flex;
  align-items: center;
}

.contact-icon .contact-icon-item:last-child .tip-img p:last-child {
  margin-bottom: 0;
}

.contact-icon .contact-icon-item:last-child .tip-img p svg {
  margin-right: 4px;
}

.contact-icon .contact-icon-item .tip-img img {
  width: 158px;
  height: 158px;
}

.contact-icon .contact-icon-item:hover .tip-img,
.contact-icon .contact-icon-item .tip-img:hover {
  opacity: 1;
  visibility: visible;
  z-index: 99;
  transition: opacity 0.3s ease, visibility 0s linear 0s;
}

.footer-bottom {
  margin-top: 18px;
  display: flex;
  justify-content: center;
  width: 100%;
}

.footer-bottom p {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(146, 158, 176, 0.6);
  font-size: 16px;
  font-weight: 400;
  line-height: 170%;
  flex-wrap: wrap;
  justify-content: center;
}

.footer-bottom a {
  color: rgba(146, 158, 176, 0.6);
  text-decoration: none;
}

.footer-bottom a:hover {
  color: #fff;
}

.footer-divider {
  width: 1px;
  height: 16px;
  background: rgba(146, 158, 176, 0.3);
}

@media screen and (max-width: 1000px) {
  .footer-shell {
    padding-top: 24px;
    padding-bottom: 96px;
    align-items: stretch;
  }

  .footer-top {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .footer-company {
    font-size: 20px;
  }

  .footer-contact-list {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .footer-contact-item,
  .footer-address-item {
    font-size: 14px;
  }

  .footer-middle {
    margin-top: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }

  .footer-addresses {
    gap: 12px;
    justify-content: flex-start;
  }

  .footer-address-row {
    align-items: flex-start;
  }

  .footer-qrs {
    width: 100%;
    justify-content: flex-start;
    gap: 16px;
  }

  .footer-qr-card {
    width: calc(50% - 8px);
    cursor: pointer;
  }

  .footer-qr-frame {
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
  }

  .footer-qr-frame img {
    width: 100%;
    height: 100%;
  }

  .footer-bottom {
    margin-top: 24px;
    justify-content: flex-start;
  }

  .footer-bottom p {
    justify-content: flex-start;
    gap: 6px;
    font-size: 12px;
    line-height: 150%;
  }

  .footer-divider {
    height: 12px;
  }

  .mobile-popup {
    position: fixed;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .contact-icon .contact-icon-item .tip-img {
    display: none;
  }

  .popup-content {
    background: linear-gradient(180deg, #E0E6F4 0%, #FFF 100%);
    border-radius: 12px;
    padding: 20px;
    width: 85%;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    position: relative;
    z-index: 1001;
  }

  .popup-header {
    margin-bottom: 16px;
  }

  .popup-header h3 {
    color: #1D2129;
    font-size: 20px;
    font-weight: 400;
    margin: 0;
    text-align: center;
  }

  .popup-body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .popup-body img {
    width: 100%;
    height: auto;
    margin-bottom: 10px;
    border-radius: 8px;
    border: 1px solid #D9DBDF;
    padding: 5px;
    background: #fff;
  }

  .popup-body p {
    color: #666;
    font-size: 14px;
    margin: 0;
  }

  .address-popup .popup-header h3 {
    color: #333;
    font-size: 16px;
    font-weight: 500;
    margin: 0;
  }

  .address-popup .popup-body {
    align-items: flex-start;
  }

  .address-popup .popup-body p {
    color: #50627F;
    font-size: 14px;
    margin-bottom: 16px;
    line-height: 2;
    display: flex;
    align-items: flex-start;
  }

  .address-popup .popup-body p svg {
    margin-right: 8px;
    margin-top: 2px;
  }

  .popup-close {
    cursor: pointer;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: -56px;
    left: 50%;
    transform: translateX(-50%);
  }

  .popup-overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
}
</style>
